// src/pages/auth/RegisterSuccess.js
import { useLocation, useNavigate } from "react-router-dom";
import { Link } from "react-router-dom";
import { useContext, useEffect } from "react";
import Logo from "../../components/logo/Logo";
import { ThemeContext } from "../../context/ThemeContext";
import DynamicBackButton from "../../components/backbutton/BackButton";
import config from "../../config/config";
import Image from "../../components/image/Image";
import { useTranslation } from "react-i18next";
import { useCompanyAuthPath } from "../../hooks/useCompanyAuthPath";

const RegisterSuccess = () => {
  const location = useLocation();
  const theme = useContext(ThemeContext);
  const navigate = useNavigate();
  const { t: trans } = useTranslation();
  const { companyPath } = useCompanyAuthPath();

  useEffect(() => {
    if (!location.state?.fromRegister) {
      navigate(companyPath("register"));
    }
  }, [location, navigate, companyPath]);

  return (
    <div
      className="register-container"
      style={{
        "--bg-img": theme?.background_image
          ? `url(${config.assetsBaseUrl}/${theme.background_image})`
          : `url('images/dream-house.png')`,
      }}
    >
      <style>
        {`
          body {
            background-color: #f6f8fc;
          }
        `}
      </style>

      <div className="reg-cont-inner">
        <div className="reg-logo">
          <Logo type="secondaryWhite" size={196} />
        </div>

        <div className="reg-frm">
          <DynamicBackButton />
          <div className="register-success">
            <div className="reg-success-img">
              <img src={Image.registersuccess} alt={trans("register_success_title")} />
            </div>

            <div className="reg-success-content">
              <h2>{trans("register_success_title")}</h2>
              <p>{trans("register_success_line1")}</p>
              <p>{trans("register_success_line2")}</p>
              {/*}  <p>
                <Trans i18nKey="register_success_line3" components={{ b: <b /> }} />
              </p> */}
            </div>
          </div>

          <div className="reg-details-head ftrlink">
            <p>{trans("register_footer_help")}</p>
            <Link to={companyPath("contact")} rel="noopener noreferrer" className="heading-b" >{trans("register_footer_link")}</Link>

          </div>
        </div>
      </div>
    </div>
  );
};

export default RegisterSuccess;
